import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackbarAction } from '../snackbar-action.model';
import { SnackbarType } from '../snackbar-type.model';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'aipb-shared-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule]
})
export class SnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      message: string;
      type: SnackbarType;
      action?: SnackbarAction;
    }
  ) {}

  get icon(): string {
    switch (this.data.type) {
      case 'info':
        return 'info';
      case 'success':
        return 'check_circle';
      case 'warn':
        return 'error';
      case 'error':
        return 'cancel';
    }

    return 'info';
  }

  get message(): string {
    return this.data.message;
  }

  get action(): SnackbarAction {
    return this.data.action;
  }

  onAction(): void {
    if (!this.action && !this.action.action) return;

    this.action.action();
  }
}
